import React, { Component } from 'react';

import './index.css';

import SiteLogo from '../resources/images/dartboard.jpg'

class Header extends Component {
  render() {
    return (
      <div className="odieworks_header">
        <div className='ow-header-left' >
          <div id='ow-header-logo'>
            <img src={SiteLogo} />
          </div>
        </div>

        <div className='ow-header-right'>

        </div>

        <div className='ow-header-bottom' />

      </div>
    );
  }
}

export default Header;
